import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { IVisitDetails } from '@app/shared/models/visit-details.model';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  private cachedVisitId: string;
  private cachedVisitDetails$: Observable<IVisitDetails>;

  constructor(private http: HttpClient) { }

  getVisitDetails(visitId: string): Observable<IVisitDetails> {
    if (this.cachedVisitId === visitId) {
      return this.cachedVisitDetails$;
    }
    this.cachedVisitId = visitId;
    this.cachedVisitDetails$ = this.http.get<IVisitDetails>(`/api/visits/${visitId}`)
      .pipe(shareReplay(1));

    return this.cachedVisitDetails$;
  }
}
